import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IDeliveryMethodsState } from '../../types/store';

const initialState: IDeliveryMethodsState = {
  cod: false,
  mpaisa: false,
  mycash: false,
  bsp: false,
  schedule: false,
  instant: false,
  priority: false,
  standard: false,
  cnc: false,
};

const settingsSlice = createSlice({
  name: 'settingsSlice',
  initialState,
  reducers: {
    setSetting: (
      state,
      action: PayloadAction<{ key: keyof IDeliveryMethodsState; value: boolean }>,
    ) => {
      state[action.payload.key] = action.payload.value;
    },
  },
});

export const { setSetting } = settingsSlice.actions;
export default settingsSlice.reducer;
